import { render, staticRenderFns } from "./OrderItemMul.vue?vue&type=template&id=1ebad028&scoped=true"
import script from "./OrderItemMul.vue?vue&type=script&lang=js"
export * from "./OrderItemMul.vue?vue&type=script&lang=js"
import style0 from "./OrderItemMul.vue?vue&type=style&index=0&id=1ebad028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebad028",
  null
  
)

export default component.exports